import { useEffect, useRef } from 'react';

type VoidFn = () => void;

export function useInterval(callback: VoidFn, delay: number) {
  const savedCallback = useRef<VoidFn>();

  // Remember the latest callback.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      if (savedCallback.current) {
        savedCallback.current();
      }
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}

export function useAutoTrackingRef<T>(val: T) {
  const callbackRef = useRef(val);

  useEffect(() => {
    callbackRef.current = val;
  }, [val]);

  return callbackRef;
}
